import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { PymesSeleccionComponent } from './pymes-seleccion/pymes-seleccion.component';
import { PymesMedicoConcertadoComponent } from './pymes-medico-concertado/pymes-medico-concertado.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OptionCard } from '../../../interfaces/optionCard.interface';

@Component({
  selector: 'app-producto-destacado',
  standalone: true,
  imports: [CommonModule, PymesMedicoConcertadoComponent, TranslateModule, CaButtonComponent, PymesSeleccionComponent],
  templateUrl: './producto-destacado.component.html',
  styleUrls: ['./producto-destacado.component.scss']
})
export class ProductoDestacadoComponent implements OnInit {


  readonly coverageOptions: OptionCard[] = [
    {
      id: 'con-hospitalizacion',
      title: 'CON HOSPITALIZACIÓN',
      description:
        'Cubre la asistencia primaria, especialistas, pruebas diagnósticas, tratamientos, hospitalización e intervención.'
    },
    {
      id: 'sin-hospitalizacion',
      title: 'SIN HOSPITALIZACIÓN',
      description:
        'Cubre la asistencia primaria, especialistas, pruebas diagnósticas y tratamientos. No cubre hospitalización e intervención.'
    }
  ];

  readonly medicalOptions: OptionCard[] = [
    {
      id: 'cuadro-medico-concertado',
      title: 'CUADRO MÉDICO CONCERTADO',
      description:
        'El cliente podrá acudir a una red de profesionales, clínicas y hospitales concertados con la aseguradora.'
    },
    {
      id: 'cuadro-medico-libre',
      title: 'CUADRO MÉDICO LIBRE',
      description:
        'Si el cliente realiza una consulta, tratamiento o intervención fuera del cuadro médico, la aseguradora asume hasta el 90% de los gastos. Además, tendrá acceso al cuadro concertado.'
    }
  ];

  readonly ageOptions: OptionCard[] = [
    {
      id: 'menos',
      title: 'MENOS DE 20 ASEGURADOS',
      description: '(Mínimo 2 empleados)'
    },
    {
      id: 'mas',
      title: 'MÁS DE 20 ASEGURADOS',
      description:
        '(Incluidos 20 asegurados y hasta 50)'
    }
  ];

  readonly utilityLinks: string[] = [
    'Calculadora Ahorro Fiscal',
    'Preguntas y Objeciones Frecuentes',
    'Cuadro Médico',
    'Ver todos los Productos Salud PYME',
    'Documentación necesaria para la contratación',
    '¿Qué son el COPAGO y las CARENCIAS?'
  ];



  selectedCoverage: string | null = null;
  selectedMedicalOption: string | null = null;
  selectedInfoPymes: string = null;
  form!: FormGroup
  hospitalization: boolean = null;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      coverage: [null],
      medical: [null],
      age: [null],
      protocol: [null],
    });
  }


  ngOnInit(): void {
    // this.initFormFromSessionStorage();
    this.listenFormChanges();
  }

  // private initFormFromSessionStorage(): void {
  //   const storedForm = sessionStorage.getItem('pymesForm');
  //   if (!storedForm) {
  //     return;
  //   }
  //   const formValue = JSON.parse(storedForm);

  //   this.form.patchValue(formValue);
  // }

  private listenFormChanges(): void {
    this.form.valueChanges
      .subscribe(value => {
        if (value["coverage"] === "sin-hospitalizacion")
          this.hospitalization = false;

        else if (value["coverage"] === "con-hospitalizacion")
          this.hospitalization = true;

      }
      );
  }

  setProtocol(protocol: number | null): void {
    const protocolControl = this.form.get('protocol');

    if (!protocolControl) {
      return;
    }

    if (protocolControl.value === protocol) {
      return;
    }


    protocolControl.setValue(protocol, { emitEvent: false });
  }

  get secondSectionTitle(): string {
    return this.selectedCoverage === 'sin-hospitalizacion'
      ? 'SIN HOSPITALIZACIÓN'
      : 'CON HOSPITALIZACIÓN';
  }

  // selectCoverage(id: string): void {
  //   this.selectedCoverage = id;
  // }

  // selectMedicalOption(id: string): void {
  //   this.selectedMedicalOption = id;
  // }

  volverADatos() {
    this.form.reset();
  }

  guardarProyecto(): void {
    // console.log('guardando')
  }


  onUtilityClick(item: string): void {
    // console.log('Click en utilidad:', item);
  }

  trackByOptionId(_: number, option: OptionCard): string {
    return option.id;
  }

  trackByUtilityLink(_: number, item: string): string {
    return item;
  }
}